import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChatHeader = ({ onNewChat, messageCount }) => {
  return (
    <div className="border-b border-border bg-card px-4 py-3 md:px-6 md:py-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 md:gap-4 flex-1 min-w-0">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center flex-shrink-0">
            <Icon name="Bot" size={24} color="#FFFFFF" />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-base md:text-lg font-semibold text-foreground">
              Assistant d'Orientation
            </h2>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-success animate-pulse"></span>
              <span className="text-xs md:text-sm text-muted-foreground">
                En ligne • {messageCount} message{messageCount !== 1 ? 's' : ''}
              </span>
            </div>
          </div>
        </div>

        <Button
          variant="outline"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          onClick={onNewChat}
          className="flex-shrink-0"
        >
          <span className="hidden sm:inline">Nouvelle conversation</span>
          <span className="sm:hidden">Nouveau</span>
        </Button>
      </div>
    </div>
  );
};

export default ChatHeader;